import * as api from '../api';

const USERLOCATION = '/users/me/location';

export const isVerified = (slugId) => api.get(`${USERLOCATION}/${slugId}/isVerified`, undefined);

export const validateLocation = (slugId, data) => api.post(`${USERLOCATION}/${slugId}/validate`, data);
